import React, { useEffect, useState } from "react";
import Pagination from "../../../utils/Paginate";
import TableLoader from "../../../Skeleton/TableLoader";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import { apiHeader } from "../../../utils/apiHeader";
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");
const ListContentDescriptorTypes = () => {
//   const { token, userMetadata } = useAuth();
	const token = globalConfig.hardcoded_header;
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [state, setState] = useState({
    contentDescriptorTypes: [],
    filteredContentDescriptorTypes: [],
  });

  useEffect(() => {
    handleOnLoad();
  }, []);

  useEffect(() => {
    handleSearch(search);
  }, [search]);
  useEffect(() => {
    console.log(state);
  }, [state]);
  const handleOnLoad = () => {
    setLoading(true);
    axios
      .get(
        `${globalConfig.apiDatahubUrl}/content-descriptor-types `,
        apiHeader(token)
      )
      .then((res) => {
        const contentDescriptorTypes = res.data;
        console.log(contentDescriptorTypes);
        setState({
          ...state,
          contentDescriptorTypes: contentDescriptorTypes,
          filteredContentDescriptorTypes: contentDescriptorTypes,
        });
        setLoading(false);
        console.log(res.data[0]);
      })
      .catch((x) => {
      });
  };
  function onDelete(event) {
    let deleteID = event.target.id;
    axios
      .delete(
        `${globalConfig.apiDatahubUrl}/content-descriptor-types/` + deleteID,
        apiHeader(token)
      )
      .then((res) => {
        console.log("Delete Response:" + res.data);
        setState({
          ...state,
          contentDescriptorTypes: [],
          filteredContentDescriptorTypes: [],
        });
        handleOnLoad();
      })
      .catch((err) => console.log("Err delete:" + err));

    setState({
      ...state,
      contentDescriptorTypes: [],
      filteredContentDescriptorTypes: [],
    });
    handleOnLoad();
    // this.props.history.push("/list-content-descriptors");
  }

  const handleSearch = (search) => {
    let URL = `${globalConfig.apiDatahubUrl}/content-descriptor-types?filter[limit]=50`;
    URL += `&filter[where][or][0][contentDescriptorTypeName][regexp]=/(${search})/i&filter[where][or][1][contentDescriptorTypeDescr][regexp]=/(${search})/i`;
    axios.get(URL, apiHeader(token)).then((res) => {
      const contentDescriptorTypes = res.data;
      console.log(contentDescriptorTypes);
      setState({
        ...state,
        filteredContentDescriptorTypes: contentDescriptorTypes,
      });
      console.log(res.data[0]);
    })
    .catch((x) => {
    });
  };
  const indexOfLastData = currentPage * globalConfig.dataPerPage;
  const indexOfFirstData = indexOfLastData - globalConfig.dataPerPage;
  const currentData = state.filteredContentDescriptorTypes.slice(
    indexOfFirstData,
    indexOfLastData
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  //handler for page
  const handlePage = (page) => {
    setCurrentPage(page);
  };
  return (
    <form>

    	<div style={{ display: "flex", justifyContent: "space-between" }}>
    		<h4>Content Descriptor Types</h4>
		<div style={{display:"flex",justifyContent:"flex-end"}}>
        <Link to="/breeze/create-content-descriptor-type">
          <Button
            variant="contained"
            color="success"
          >
            Create
          </Button>
        </Link>&nbsp;
        <Link to="/breeze/list-content-descriptors">
          <Button
            variant="contained"
            color="warning"
          >
            Descriptors
          </Button>
        </Link>&nbsp;
		<Link to="/breeze">
			<Button variant="contained">Go Back</Button>
		</Link>
		</div>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group">
          <input
            className="form-control"
            type="search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            id="exampleFormControlInput1"
            placeholder="Search"
          />
        </div>
        <div className="form-group row">
          <table className="table table-bordered table-striped">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Description</th>
                <th scope="col">Code</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {!loading ? (
                currentData.map(
                  ({
                    contentDescriptorTypeId,
                    contentDescriptorTypeName,
                    contentDescriptorTypeDescr,
                    contentDescriptorTypeValue,
                  }) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-descriptor-types",
                              search: `?id=${contentDescriptorTypeId}`,
                            }}
                          >
                            {contentDescriptorTypeId}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-descriptor-types",
                              search: `?id=${contentDescriptorTypeId}`,
                            }}
                          >
                            {contentDescriptorTypeName}
                          </Link>{" "}
                        </td>
                        <td>
                          {" "}
                          <Link
                            to={{
                              pathname: "/manage-content-descriptor-types",
                              search: `?id=${contentDescriptorTypeId}`,
                            }}
                          >
                            {contentDescriptorTypeDescr}
                          </Link>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/manage-content-descriptor-types",
                              search: `?id=${contentDescriptorTypeId}`,
                            }}
                          >
                            {" "}
                            {contentDescriptorTypeValue}
                          </Link>
                        </td>
                        <td>
                          <Link
                            className="btn btn-success"
                            to={{
                              pathname: "/manage-content-descriptor-types",
                              search: `?id=${contentDescriptorTypeId}`,
                            }}
                          >
                            Edit{" "}
                          </Link>
                          &nbsp;
                          <button
                            onClick={onDelete}
                            id={contentDescriptorTypeId}
                            className="btn btn-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    );
                  }
                )
              ) : (
                <tr>
                  {new Array(5).fill(0).map((_, index) => (
                    <TableLoader key={index} theme={"dark"} />
                  ))}
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <Pagination
          dataPerPage={globalConfig.dataPerPage}
          totaldata={state.filteredContentDescriptorTypes.length}
          paginate={paginate}
          currentPage={currentPage}
          onChange={handlePage}
        />
      </div>
    </form>
  );
};

export default ListContentDescriptorTypes;
